import React, { useEffect, useRef, useState } from 'react'
import {
  Button,
  Col,
  Row,
  Table,
  Image,
  Form,
  ButtonToolbar,
  OverlayTrigger,
  Tooltip,
  InputGroup
} from 'react-bootstrap'
import NavTitle from '../../../nav-title'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import { getTeamsAPI } from '../../../../services/teams'
import {
  BsChevronLeft,
  BsChevronRight,
  BsPlusLg,
  BsSearch
} from 'react-icons/bs'
import EditTeam from './edit-team'
import {
  PAGE_SETTING,
  PIM_ORG_DEPARTMENT,
  PIM_ORG_FACTION,
  PIM_ORG_POSITION
} from '../../../../router/routes'
import AddTeam from './add-team'
import { useDebounce } from '@react-hook/debounce'
import TextNavTitle from '../../../TextNavTitle'
import detailImg from '../../../../images/Detail.svg'
import editImg from '../../../../images/Edit.svg'
import CardCustom from '../../../custom/card-custom'
import useThaiInput from '../../../../helper/input-fix-th'
import useEngInput from '../../../../helper/input-fix-en'
import useNumberInput from '../../../../helper/input-fix-num'
import TableSkeletonBody from '../../../custom/TableSkeletonBody'

export default function Index() {
  let [searchParams, setSearchParams] = useSearchParams()
  const orgId = searchParams.get('orgId')
  const divisionId = searchParams.get('divisionId')
  const departmentId = searchParams.get('departmentId')
  const factionId = searchParams.get('factionId')
  const positionId = searchParams.get('positionId')
  const teamId = searchParams.get('teamId')
  const [dataTable, setdataTable] = useState([])
  const [showCreate, setShowCreate] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [detailTable, setDetailTable] = useState()
  const [isSave, setIsSave] = useState(false)
  const navigate = useNavigate()
  const param = { orgId, divisionId, departmentId, teamId, positionId }
  const [isRefresh, setIsRefresh] = useState(false)
  const divisionName = searchParams.get('nameGroup')
  const factionName = searchParams.get('nameDepartment')
  const departmentName = searchParams.get('nameDivision')
  const teamName = searchParams.get('nameTeam')

  const [filteredData, setFilteredData] = useState([])
  const [input, setInput] = useDebounce('', 1000)
  const inputRef = useRef(null)
  const handleKeyDownTH = useThaiInput(inputRef)
  const handleKeyDownEN = useEngInput(inputRef)
  const handleKeyDownNum = useNumberInput(inputRef)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsRefresh(false)
  }, [isRefresh])

  useEffect(() => {
    setFilteredData(dataTable)
  }, [dataTable])

  useEffect(() => {
    getTeams()
    setIsRefresh(false)
  }, [isRefresh, input])

  const getTeams = async () => {
    setIsLoading(true)
    const result = await getTeamsAPI({
      ...param,
      searchs: input
    })
    setIsLoading(false)
    if (!result) return
    if (result.status) {
      setdataTable(result.result)
    }
  }

  const handleEditButtonClick = () => {
    setShowEdit(true)
  }

  const handleClick = (d) => {
    navigate(
      `${PIM_ORG_POSITION}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}&factionId=${factionId}&nameDepartment=${factionName}&departmentId=${departmentId}&nameDivision=${departmentName}&teamId=${d.id}&nameTeam=${d.team_en}`
    )
  }

  return (
    <Row>
      <NavTitle>
        <TextNavTitle>
          <Link
            className="link"
            style={{ color: '#7A7A7A' }}
            onClick={() => {
              navigate(-1)
            }}
          >
            <BsChevronLeft /> Team
          </Link>
        </TextNavTitle>
      </NavTitle>
      <p className="fw-normal  text-secondary">
        <Link
          className="link text-secondary "
          to={`${PAGE_SETTING}?orgId=${orgId}`}
        >
          Group
        </Link>

        <Link
          className="link text-secondary"
          to={`${PAGE_SETTING}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}`}
        >
          {`: ${divisionName}`}
        </Link>
        <Link
          className="link text-secondary"
          to={`${PIM_ORG_FACTION}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}&factionId=${factionId}&nameDepartment=${factionName}`}
        >
          <BsChevronRight />
          {`Division: ${factionName}`}
        </Link>
        <Link
          className="link text-secondary"
          to={`${PIM_ORG_DEPARTMENT}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}&factionId=${factionId}&nameDepartment=${factionName}&departmentId=${departmentId}&nameDivision=${departmentName}`}
        >
          <BsChevronRight />
          {`Department: ${departmentName}`}
        </Link>
        <span className="link" style={{ color: '#C7C7C7' }}>
          <BsChevronRight /> Team
        </span>
      </p>
      <Col xl={12}>
        <CardCustom className="h-full" border="0">
          <div className="p-3 ">
            <Col
              xl={12}
              className="my-auto d-flex gap-3 justify-content-between"
              style={{ flexWrap: 'wrap' }}
            >
              <label
                className=" my-auto fw-bold"
                style={{
                  fontSize: '14px'
                }}
              >
                Total: {dataTable.length?.toLocaleString()}
              </label>
              <div className="d-flex justify-content-end gap-2">
                <span style={{ minWidth: '300px' }}>
                  <InputGroup>
                    <InputGroup.Text className="bg-white border-end-0  text-muted">
                      <BsSearch />
                    </InputGroup.Text>
                    <Form.Control
                      className="border-start-0 ps-0 placeholder-text"
                      placeholder="Team EN/ Team TH"
                      onChange={(e) => setInput(e.target.value)}
                    />{' '}
                  </InputGroup>
                </span>
                <span>
                  <Button
                    style={{
                      minWidth: '150px'
                    }}
                    size="sm"
                    className="px-4 btn btn-primary"
                    onClick={() => setShowCreate(true)}
                  >
                    <BsPlusLg /> Add Team
                  </Button>
                </span>
              </div>
            </Col>
          </div>
          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className="font-title-table">
                <th className="fw-normal">#</th>
                <th className="fw-normal">Teams EN</th>
                <th className="fw-normal">Teams TH</th>
                <th className="fw-normal text-center"> Count of Employee</th>
                <th className="fw-normal text-center"> Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <TableSkeletonBody colSpan={5} rowSpan={10} />
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr key={i} className="fw-light font-small-2 ">
                    <td>{i + 1}</td>
                    <td className="">{d.team_en}</td>
                    <td className="">{d.team_th}</td>
                    <td className="text-center">{d.count_emp}</td>
                    <td className="text-center ">
                      <span className="d-flex justify-content-center">
                        <ButtonToolbar>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-detail">Detail</Tooltip>
                            }
                          >
                            <Button
                              variant="btn btn-outline-primary"
                              className="border-0 d-flex justify-content-center"
                              size="sm"
                              style={{
                                width: '32px',
                                height: '32px'
                              }}
                              onClick={() => {
                                handleClick(d)
                              }}
                            >
                              <Image
                                src={detailImg}
                                style={{
                                  width: '20px'
                                }}
                              />
                            </Button>
                          </OverlayTrigger>
                        </ButtonToolbar>
                        <ButtonToolbar>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-detail">Edit</Tooltip>
                            }
                          >
                            <Button
                              variant="btn btn-outline-primary"
                              className="border-0 d-flex justify-content-center"
                              size="sm"
                              style={{
                                width: '32px',
                                height: '32px'
                              }}
                              onClick={() => {
                                setDetailTable(d)
                                handleEditButtonClick()
                              }}
                            >
                              <Image
                                src={editImg}
                                style={{
                                  width: '20px'
                                }}
                              />
                            </Button>
                          </OverlayTrigger>
                        </ButtonToolbar>
                      </span>
                      {/* <BtnEditCustom
                            onClick={() => {
                              setDetailTable(d);
                              handleEditButtonClick();
                            }}
                          >
                            Edit
                          </BtnEditCustom> */}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="fw-light ">
                  <td colSpan={6} className="text-center">
                    - No data -
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardCustom>
      </Col>
      {showEdit && (
        <EditTeam
          setIsRefresh={setIsRefresh}
          isRefresh={isRefresh}
          orgId={orgId}
          divisionId={divisionId}
          departmentId={departmentId}
          detail={detailTable}
          setIsSave={setIsSave}
          showCreate={showEdit}
          isSave={isSave}
          fnGetData={getTeams}
          setShowCreate={setShowEdit}
          handleKeyDownTH={handleKeyDownTH}
          handleKeyDownEN={handleKeyDownEN}
          handleKeyDownNum={handleKeyDownNum}
        />
      )}
      {showCreate && (
        <AddTeam
          setIsRefresh={setIsRefresh}
          isRefresh={isRefresh}
          orgId={orgId}
          param={{ orgId, divisionId, departmentId }}
          setIsSave={setIsSave}
          showCreate={showCreate}
          isSave={isSave}
          fnGetData={getTeams}
          setShowCreate={setShowCreate}
          handleKeyDownTH={handleKeyDownTH}
          handleKeyDownEN={handleKeyDownEN}
          handleKeyDownNum={handleKeyDownNum}
        />
      )}
    </Row>
  )
}
